import React, {Fragment, useState} from 'react';
import Modal, {ModalBody, ModalHeader} from "../../Modal";
import {makeNewArrayOfEmptyFields} from "./permissionFunctions";
import Button from "../../UI/Button";

const SectionViewModal = ({isOpen, setIsOpen, modal, onSubmit}) => {


  const [emptyFields, setEmptyFields] = useState(modal.data.exceptionFields);
  const submitHandler = () => {
    onSubmit(emptyFields, modal.data.EnName, modal.sectionKey)
    setIsOpen({isOpen: false})
  };


  // backEnd told me  (exceptionFields) are (emptyFields) so if use unchecked someThing i Must push It in empty Arrays
  const onChangeHandler = (e) => {
    const checked = e.target.checked;
    const value = e.target.value;
    setEmptyFields(makeNewArrayOfEmptyFields(emptyFields, value, checked))
  }


  return (
    <Modal
      isOpen={isOpen}
      modalCallback={setIsOpen}
    >
      <ModalHeader title={modal.data.FaLabel}/>
      <ModalBody>

        <div className={"m-3 d-flex flex-wrap "}>
          {modal.data.fields.map((v, index) => {
            const isChecked = !emptyFields.includes(v.value)
            return <div key={index} style={{width: '200px'}}>
              <input type={'checkbox'}
                     id={index}
                     value={v.value}
                     onChange={onChangeHandler}
                     checked={isChecked}/>
              <label htmlFor={index}>{v.label}</label>

            </div>

          })}
        </div>

        <div className={'m-3 d-flex'}>

          <Button
            onClick={submitHandler}
          > ثبت</Button>
          <Button color={'btn-red'}
                  onClick={() => setIsOpen({isOpen: false})}
          > انصراف</Button>

        </div>
      </ModalBody>
    </Modal>

  );
};

export default SectionViewModal;
